import { InvoiceItemModel } from "#src/models/InvoiceItemModel.ts";
import { PrivateSerieAttendanceStatus } from "#types/code-generator.ts";
import LocationModel from "./LocationModel.ts";
import PrivateSerieModel from "./PrivateSerieModel.ts";
import UserModel from "./UserModel.ts";
import { ZoneModel } from "./ZoneModel.ts";

export const isPrivateSerieAttendance = (
  attendance
): attendance is PrivateSerieAttendanceModel =>
  attendance instanceof PrivateSerieAttendanceModel;

export default class PrivateSerieAttendanceModel {
  atAccountHome: boolean = false;
  automated: boolean = false;
  completedBy: UserModel;
  completedOn: Date;
  createdAt: Date;
  date: Date = new Date();
  duration: number;
  id: string;
  instructor: UserModel;
  invoiceItems: InvoiceItemModel[] = [];
  location: LocationModel;
  note: string;
  number: number;
  privateSerie: PrivateSerieModel;
  scheduledBy: UserModel;
  scheduledOn: Date;
  status: PrivateSerieAttendanceStatus;
  studentsAdded: UserModel[] = [];
  studentsAttended: UserModel[] = [];
  time: string;
  updatedAt: Date;
  verifiedBy: UserModel;
  verifiedOn: Date;
  zone: ZoneModel;

  constructor(data: any) {
    Object.assign(this, data);

    if (data?.privateSerie) {
      this.privateSerie = new PrivateSerieModel(data.privateSerie);
    }
  }
}
